import React, {
  Component
} from 'react';

export default class Ourmission extends Component {

  render() {
    return (
     <section className="our-mission">
       <div className="row">
         <ul>
           <li className="red"> <a href="our-science.php" target="_blank">Our Science</a> <span></span>
             <div className="shadow"></div>
           </li>
           <li className="grn"> <a href="our-technology.php" target="_blank"> Our Technology</a> <span></span>
             <div className="shadow"></div>
           </li>
           <li className="orng"> <a href="http://www.361online.com/" target="_blank"> Our Products</a> <span></span>
             <div className="shadow"></div>
           </li>
           <li className="rose"> <a href="our-alliances.php" target="_blank"> Our Alliances</a> <span></span>
             <div className="shadow"></div>
           </li>
         </ul>
         <div className="mission-txt">
           <h2>Our Mission</h2>
           <span className="line1"></span>
           <p>Make learning accessible, affordable for everyone. Anywhere. Anytime. In a wide <br/>
             variety of disciplines</p>
           <ul>
             <li>
               <div className="icon-div"><img src={process.env.PUBLIC_URL +'/images/footicon.png'} alt="" className=""/></div>
               <span>361DM Alumni <br/>
               <span className="txt-bold">25,000 professionals </span></span></li>
             <li>
               <div className="icon-div icon-div-pad"><img src={process.env.PUBLIC_URL +'/images/footicon1.png'} alt="" className=""/></div>
               <span>Corporate Reach <br/>
               <span className="txt-bold">50+ organizations</span> </span></li>
             <li>
               <div className="icon-div"><img src={process.env.PUBLIC_URL +'/images/foot_iconnew.png'} alt="" className=""/></div>
               <span>Program Bouquet <br/>
               <span className="txt-bold">60+ courses</span> </span></li>
             <li>
               <div className="icon-div"><img src={process.env.PUBLIC_URL +'/images/degreecertificate1.png'} alt="" className=""/></div>
               <span>Across the Globe<br/>
               <span className="txt-bold">55+ Cities </span></span></li>
           </ul>
         </div>
       </div>
     </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/Ourmission.js